import { slugify } from '@core/shared/utils';
import { DefaultAbilityAction } from '@core/shared/ability';
import { BaseFeature, FeatureType } from '@core/shared/feature';
export class MpfCoursesBaseFeature extends BaseFeature {
  static {
    this.featureInfo = {
      context: {"package":"@mpf/courses/feature","featureId":"mpf-courses"},
      bundledItemModels: ["SceneItem", "SceneUserProgressItem", "MandatoryCourseGroupItem", "ExamItem", "ExamResultItem", "ExamAdmissionItem", "CourseItem", "CourseTagItem", "CourseCategoryItem", "CourseAttachmentItem", "CertificateItem"],
      // list is auto-generated by generate-model-ids
      dependencies: ['common-users', 'common-mail'],
      abilityActions: [{
        action: 'Preview',
        defaultBias: 1
      }, {
        action: DefaultAbilityAction.View,
        defaultBias: -1
      }, {
        action: DefaultAbilityAction.Manage,
        defaultBias: -1
      }],
      plugins: [{
        forPlatform: 'frontend',
        type: FeatureType.Permanent,
        pluginClassName: 'MpfCoursesFrontendFeature'
      }, {
        forPlatform: 'frontend-management',
        type: FeatureType.Dynamic,
        pluginClassName: 'MpfCoursesFrontendManagementFeature',
        simpleAbilityCheck: 'Feature.common-users.Company.Manage'
      }, {
        forPlatform: 'admin',
        type: FeatureType.Permanent,
        pluginClassName: 'MpfCoursesAdminFeature'
      }, {
        forPlatform: 'backend',
        type: FeatureType.Permanent,
        pluginClassName: 'MpfCoursesBackendFeature'
      }, {
        forPlatform: 'backend-admin',
        type: FeatureType.Permanent,
        pluginClassName: 'MpfCoursesBackendAdminFeature'
      }]
    };
  }
  getSharedDefinition() {
    return {
      routerLinkResolvers: {
        frontend: {
          courses: () => '/courses',
          CourseItem: info => {
            if (typeof info === 'object') {
              return ['/courses', info.id + '-' + slugify(info.name)];
            } else {
              return ['/courses', info];
            }
          },
          SceneItem: info => {
            if (!info.course || !info.sceneId) throw new Error('SceneItem RouterLinkResolver missing params');
            if (typeof info.course === 'object') {
              return ['/courses', info.course.id + '-' + slugify(info.course.name), 'watch', info.sceneId];
            } else {
              return ['/courses', info.course, 'watch', info.sceneId];
            }
          },
          ExamItem: info => {
            if (typeof info === 'object') {
              return ['/courses', info.id + '-' + slugify(info.name), 'exam'];
            } else {
              return ['/courses', info, 'exam'];
            }
          },
          'management-statistics': subroute => '/management/courses' + (subroute ? '/' + subroute : ''),
          'management-mandatory-course-groups': subroute => '/management/courses/mandatory-courses-presets' + (subroute ? '/' + subroute : '')
        }
      },
      virtualProperties: {
        'UserItem': [{
          name: 'mandatoryCourseGroup',
          type: 'int',
          canRead: ['public'],
          canEdit: ['managerOfUser', 'admin', 'manager && self']
        }, {
          name: 'mandatoryCourses',
          type: 'json',
          canRead: ['public'],
          canEdit: ['managerOfUser', 'admin', 'manager && self']
        }]
      }
    };
  }
}